import * as Types from "@clockwise/schema";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type UpdateNotificationSettingMutationMutationVariables = Types.Exact<{
  input: Types.UpdateSettingMutationInput;
}>;

export type UpdateNotificationSettingMutationMutation = {
  __typename: "Mutation";
  updateSetting: {
    __typename: "UpdateSettingMutationPayload";
    setting: {
      __typename: "Setting";
      id: string;
      value: Array<string | null> | null;
      key: {
        __typename: "SettingKey";
        id: string;
        name: string | null;
        scope: {
          __typename: "Urn";
          id: string;
          type: Types.UrnType | null;
          value: string | null;
        } | null;
        target: {
          __typename: "Urn";
          id: string;
          type: Types.UrnType | null;
          value: string | null;
        } | null;
      } | null;
      type: {
        __typename: "SettingType";
        id: string;
        valueType: Types.ValueType | null;
        containerType: Types.ContainerType | null;
        required: boolean | null;
      } | null;
    } | null;
  } | null;
};

export const UpdateNotificationSettingMutationDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateNotificationSettingMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateSettingMutationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateSetting" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "setting" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "key" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "scope" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "target" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "type" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "valueType" } },
                            { kind: "Field", name: { kind: "Name", value: "containerType" } },
                            { kind: "Field", name: { kind: "Name", value: "required" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<
  UpdateNotificationSettingMutationMutation,
  UpdateNotificationSettingMutationMutationVariables
>;
